import { Sparkle } from "lucide-react";
import { marqueeItems } from "@/data/content";

export default function Marquee() {
  const doubled = [...marqueeItems, ...marqueeItems];
  return (
    <div
      data-testid="values-marquee"
      className="relative overflow-hidden border-y border-brand-royal/20 bg-brand-royal py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center gap-8">
        {doubled.map((item, i) => (
          <span key={i} className="flex items-center gap-8 whitespace-nowrap">
            <span className="font-display text-sm sm:text-base font-bold uppercase tracking-[0.2em] text-white">
              {item}
            </span>
            <Sparkle className="h-4 w-4 text-brand-orange" />
          </span>
        ))}
      </div>
    </div>
  );
}
